import Image from 'next/image';
import React from 'react';

const IntegrationsTechVisionMultimodal = () => {
    return (
        <div className="section-py !pt-0 !pb-0 dark:bg-black">
            <div className="container lg:container mx-auto">
                <div className="row grid lg:grid-cols-12">
                    <div className="lg:col-span-10 pb-10">
                        <h2 className="mb-4 dark:text-white" data-aos="fade-up" data-aos-duration="700" data-aos-delay="100">
                            Integrations & Tech Stack
                        </h2>
                        <p className='mb-0' data-aos="fade-up" data-aos-duration="700" data-aos-delay="100">
                            We leverage the latest frameworks and platforms to build robust, scalable vision and multimodal AI solutions. Our technology infrastructure combines enterprise-grade tools and advanced architectures to deliver seamless integration, performance optimization, and production-ready deployment for sophisticated computer vision and multimodal intelligence systems.
                        </p>
                    </div>
                </div>
                <div className="row grid xl:grid-cols-2 lg:grid-cols-2 md:grid-cols-2 mb-[30px]">
                    <div className="card p-5 dark:bg-[#3C45611A] dark:border-[#ffffff33] dark:border-solid" data-aos="fade-up" data-aos-duration="700" data-aos-delay="100">
                        <div className="voice-generator-box mb-3">
                            <Image
                                src="/img/vision-and-multimodal-ai/svg/ic-framework.svg"
                                width={36}
                                height={36}
                                alt="Frameworks"
                            />
                        </div>
                        <p className="fw-700 dark:text-white mb-1">Frameworks</p>
                        <p className="fs-md mb-0 fw-500 dark:text-[#D7DEE5]">
                            We build end-to-end computer vision pipelines using industry-leading frameworks that enable rapid development, model training, experimentation, and deployment of state-of-the-art vision models.
                        </p>
                    </div>
                    <div className="card p-5 dark:bg-[#3C45611A] dark:border-[#ffffff33] dark:border-solid" data-aos="fade-up" data-aos-duration="700" data-aos-delay="100">
                        <div className="voice-generator-box mb-3">
                            <Image
                                src="/img/vision-and-multimodal-ai/svg/ic-multimodal-models.svg"
                                width={36}
                                height={36}
                                alt="Multimodal Models"
                            />
                        </div>
                        <p className="fw-700 dark:text-white mb-1">Multimodal Models</p>
                        <p className="fs-md mb-0 fw-500 dark:text-[#D7DEE5]">
                            Advanced multimodal architectures enable seamless fusion of visual, textual, and sensor data, unlocking new capabilities for intelligent systems that understand and reason across multiple modalities.
                        </p>
                    </div>
                </div>
                <div className="row grid xl:grid-cols-3 lg:grid-cols-3 md:grid-cols-3">
                    <div className="card p-5 dark:bg-[#3C45611A] dark:border-[#ffffff33] dark:border-solid" data-aos="fade-up" data-aos-duration="700" data-aos-delay="100">
                        <div className="voice-generator-box mb-3">
                            <Image
                                src="/img/vision-and-multimodal-ai/svg/ic-deployment.svg"
                                width={36}
                                height={36}
                                alt="Deployment Tools"
                            />
                        </div>
                        <p className="fw-700 dark:text-white mb-1">Deployment Tools</p>
                        <p className="fs-md mb-0 fw-500 dark:text-[#D7DEE5]">
                            Optimized inference engines and cloud platforms ensure production-scale deployment with maximum performance, efficiency, and reliability across devices, cloud infrastructure, and hybrid environments.
                        </p>
                    </div>
                    <div className="card p-5 dark:bg-[#3C45611A] dark:border-[#ffffff33] dark:border-solid" data-aos="fade-up" data-aos-duration="700" data-aos-delay="100">
                        <div className="voice-generator-box mb-3">
                            <Image src="/img/vision-and-multimodal-ai/svg/ic-data-management.svg" width={36} height={36} alt="Data Management" />
                        </div>
                        <p className="fw-700 dark:text-white mb-1">Data Management</p>
                        <p className="fs-md mb-0 fw-500 dark:text-[#D7DEE5]">
                            Streamlined annotation, dataset versioning, and experiment tracking tools accelerate the entire vision AI pipeline from data preparation to model refinement, evaluation, and production deployment.
                        </p>
                    </div>
                    <div className="card p-5 dark:bg-[#3C45611A] dark:border-[#ffffff33] dark:border-solid" data-aos="fade-up" data-aos-duration="700" data-aos-delay="100">
                        <div className="voice-generator-box mb-3">
                            <Image
                                src="/img/llms-aiml/svg/ic_mlops.svg"
                                width={36}
                                height={36}
                                alt="MLOps"
                            />
                        </div>
                        <p className="fw-700 dark:text-white mb-1">MLOps</p>
                        <p className="fs-md mb-0 fw-500 dark:text-[#D7DEE5]">
                            Automated training orchestration, containerization, and continuous deployment frameworks enable efficient model lifecycle management, version control, and scalable production operations with monitoring.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default IntegrationsTechVisionMultimodal;
